import { css } from 'styled-components';
import theme from 'theme/theme';
import { media } from 'theme/utils';

const { colors } = theme;

export const styleBase = css`
  &&& {
    padding: 3.7em 2em;
    text-align: center;
    background-color: ${colors.white};

    h1 {
      color: ${colors.primaryDarkBlue};
      font-size: 2.38em;
      font-weight: 800;
      line-height: 1.1;
      letter-spacing: -1px;
      margin: 1.3rem 0 1rem;
    }

    div[class*='images'] {
      max-width: 23em;
    }

    div[class*='embeddedAsset'] img {
      width: 100%;
    }

    div[class*='descriptionWrapper'],
    div[class*='feature'] div[class*='description'] {
      > div {
        padding-bottom: 1.3em;
        line-height: 1.26;

        &:last-child {
          padding-bottom: 0;
        }
      }

      button {
        margin-top: 0.5rem;
      }
    }

    ${media.md`
      padding: 3.7em 1.2em;
      text-align: left;

      h1 {
        font-size: 2.9em;
      }

      div[class*='content'] {
        flex-direction: row;
        align-items: center;

        > div {
          flex: 0 1 50%;
        }
      }

      div[class*='images'] {
        max-width: none;
        padding-right: 1.6em;
      }

      div[class*='descriptionWrapper'] {
        align-items: unset;
      }
    `}

    ${media.lg`
      padding: 5.7em 1.2em;

      h1 {
        font-size: 3.4em;
        margin-bottom: 0.5em;
      }

      div[class*='content'] {
        max-width: 72em;
        margin: 0 auto;
      }

      div[class*='descriptionWrapper'] {
        max-width: 30em;
      }
    `}
  }
`;

export const styleReverse = css`
  &&& {
    ${media.md`
      div[class*='content'] {
        flex-direction: row-reverse;
      }

      div[class*='images'] {
        padding-left: 1.6em;
        padding-right: 0;
      }
    `}
  }
`;

export const styleHero = css`
  ${styleBase}

  &&& {
    padding: 1.1em 0.5em 5.5em;
    background-color: ${colors.primaryBlue};

    div[class*='descriptionWrapper'] {
      h1 {
        color: white;
        line-height: 1;
      }

      div[class*='subtitle'] {
        color: white;
      }

      > div {
        padding-left: 0.7em;
        padding-right: 0.7em;
        font-weight: 600;
      }
    }

    ${media.md`
      padding: 2.6em 4em 2.6em;
      text-align: left;

      h1 {
        font-size: 2.38em;
      }

      div[class*='content'] {
        flex-direction: column;
        align-items: flex-start;

        > div {
          flex: unset;
        }
      }

      div[class*='images'] {
        padding-right: 0;
      }

      div[class*='descriptionWrapper'] {
        width: 24em;

        > div {
          padding-left: 0;
          padding-right: 0;
          font-weight: normal;
        }
      }
    `}

    ${media.lg`
      padding: 0;

      h1 {
        font-size: 3.4em;
      }

      div[class*='content'] {
        justify-content: center;
        max-width: 60em;
        height: 45em;
      }

      div[class*='descriptionWrapper'] {
        width: unset;
        max-width: 37em;
      }
    `}
  }
`;

export const styleNoImages = css`
  &&& {
    > div[class*='content'] {
      justify-content: center;

      > div {
        flex: unset;
      }

      > div[class*='images'] {
        display: none;
      }
    }
  }
`;

export const styleFeatures = css`
  ${styleBase}
  ${styleNoImages}

  &&& {
    div[class*='featuresList'] {
      margin: 0;

      div[class*='feature'] {
        margin-bottom: 3em;

        &:last-child {
          margin-bottom: 0;
        }

        img {
          width: 100%;
          max-width: 16em;
        }

        > img + span {
          display: none;
        }

        div[class*='description'] {
          margin-top: 2.5em;

          h2 {
            margin-top: 0;
            font-weight: 800;
            letter-spacing: -0.3px;
          }

          a {
            color: black;
            text-decoration: underline;
          }
        }
      }
    }

    ${media.md`
      padding-left: 4em;
      padding-right: 4em;

      div[class*='descriptionWrapper'] {
        max-width: 49em;
      }

      div[class*='featuresList'] {
        div[class*='feature'] {
          flex-flow: row nowrap;
          align-items: flex-start;

          div[class*='description'] {
            flex: 1 0 69%;
            margin: 0 0 0 3em;
          }
        }
      }
    `}

    ${media.lg`
      div[class*='featuresList'] div[class*='feature'] {
        align-items: center;
      }
    `}
  }
`;
